import axios from 'axios';

function axiosProvider(baseUrl) {
  return axios.create({
    baseURL: baseUrl,
  });
}

export default axiosProvider;
